<template>
  <div>
    
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1200px">
      <material-card
        :title="formTitle"
        :icon="formIcon"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col xs="12" sm="6" md="4" lg="3">
                  <pbas-date-picker
                    :label="$t('globals.effective_date')"
                    :value="effectiveDate"
                    @update-date="effectiveDate=$event"
                    :rules="[$rules.required]"
                    class="required"
                  ></pbas-date-picker>
                </v-col>
              </v-row>
              <template v-if="item && effectiveDate">
                <v-row>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <no-autocomplete-textfield
                      v-model="item.Identity.FirstName"
                      :label="$t('globals.firstname')"
                      :rules="[$rules.required, $rules.validName]"
                      class="required"
                      :disabled="!isNew"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <no-autocomplete-textfield
                      v-model="item.Identity.LastName"
                      :label="$t('globals.lastname')"
                      :rules="[$rules.required, $rules.validLastName]"
                      class="required"
                      :disabled="!isNew"
                    ></no-autocomplete-textfield>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="text-h6 ml-1">
                      {{ $t("globals.address") }}
                    </span>
                    <canada-post-address
                      :address="item.Address"
                      @update-address="item.Address = $event"
                      @valid="valid.address = $event"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <no-autocomplete-textfield
                      v-model="item.Email"
                      :label="$t('headers.contacts.email')"
                      :rules="[$rules.email]"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <no-autocomplete-textfield
                      v-model="item.PhoneNumber"
                      :label="$t('globals.telephone')"
                      :rules="[rules.phone]"
                      v-mask="telephoneMask"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <no-autocomplete-textfield
                      v-model="item.BrokerLicensing"
                      :label="$t('headers.brokers.broker_licensing')"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <pbas-date-picker
                      :label="
                        $t('headers.brokers.broker_licensing_expiry_date')
                      "
                      :value="item.BrokerLicensingExpiryDate"
                      @update-date="item.BrokerLicensingExpiryDate = $event"
                    ></pbas-date-picker>
                  </v-col>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <no-autocomplete-textfield
                      v-model="item.EOLicensing"
                      :label="$t('headers.brokers.eo_licensing')"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <pbas-date-picker
                      :label="$t('headers.brokers.eo_licensing_expiry_date')"
                      :value="item.EOLicensingExpiryDate"
                      @update-date="item.EOLicensingExpiryDate = $event"
                    ></pbas-date-picker>
                  </v-col>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <no-autocomplete-textfield
                      v-model="item.TaxNumber"
                      :label="$t('headers.brokers.tax_number')"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col xs="12" sm="6" md="4" lg="3">
                    <trans-textbox
                      v-model="item"
                      :label="$t('headers.brokers.brokerage_name')"
                      field="BrokerageName"
                    ></trans-textbox>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.edit = false;item=null;effectiveDate=null;">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            :loading="saving"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="loading" persistent max-width="400">
      <v-card>
        <v-card-title>
          {{ $t("globals.please_wait") }}
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
      <material-card
        v-if="item"
        :title="
          $t('views.insurancecarriersindex.delete_insurance_carrier_{0}', [
            trans(item, 'Name'),
          ])
        "
        color="#007cb5"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="deleteItem">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog> -->
    <v-dialog scrollable v-model="dialogs.assign" persistent max-width="800px">
      <material-card
        v-if="item !== null && item !== undefined"
        :title="$t('views.brokers.assign_{0}_to_organizations', [brokerName])"
        icon="assignment_turned_in"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fluid grid-list-md>
              <v-row>
                <v-autocomplete
                  v-model="item.Organizations"
                  :items="organizations"
                  :label="$t('globals.organizations')"
                  item-value="Id"
                  item-text="Name"
                  multiple
                ></v-autocomplete>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.assign = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            :loading="saving"
            @click="assign"
          >
            {{ $t("views.brokers.assign") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
      :title="$t('components.getreports.brokers')"
      :color="$vuetify.theme.themes.light.primary"
      icon="badge"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="brokers-index"
        :exporters="$exporters"
        identifier="brokersIndexTable"
        sortBy="Name"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <v-snackbar v-model="snackbar" color="success" :timeout="2500">
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import TransTextbox from "../components/TransTextbox";
import { ODataProvider } from "pbas-vue-components";
import getHeaders from "../headers/BrokersIndex";
import { locker } from "../mixins/locker";
import { translate2 } from "../trans2";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import CanadaPostAddress from "@/components/CanadaPostAddress";

export default {
  components: {
    ErrorHandler,
    TransTextbox,
    NoAutocompleteTextfield,
    CanadaPostAddress,
  },
  directives: { mask },
  mixins: [locker],
  data() {
    return {
      loading: false,
      snackbar: false,
      valid: true,
      provider: undefined,
      saving: false,
      floatActions: [
        {
          name: "add",
          icon: "add",
          color: "#64ba5f",
          text: "globals.add_new",
          handler: () => this.addItem(),
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editItem(item),
        },
        {
          name: "assign",
          icon: "assignment_turned_in",
          title: "views.brokers.assign_to_organizations",
          handler: (item) => this.assignItem(item),
        },
        // {
        //   name: "delete",
        //   icon: "delete",
        //   title: "globals.delete",
        //   handler: (item) => {
        //     this.item = item;
        //     this.dialogs.delete = true;
        //   },
        // },
      ],
      dialogs: {
        edit: false,
        // delete: false,
        assign: false,
      },
      insuranceCarriers: [],
      isNew: false,
      item: null,
      error: null,
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
      },
      telephoneMask: "(###) ### - ####",
      effectiveDate: null,
      id:null
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    formTitle() {
      if (this.isNew) {
        return this.$t("views.brokers.new_broker");
      }
      return this.$t("views.brokers.edit_{0}", [this.brokerName]);
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    url: function () {
      return "brokers-index";
    },
    brokerName() {
      if (this.item) {
        if (this.item.Identity) {
          return `${this.item.Identity.FirstName} ${this.item.Identity.LastName}`;
        }
        return `${this.item.FirstName} ${this.item.LastName}`;
      }
      return "";
    },
  },
  watch: {
    effectiveDate: {
      handler(v) {
        if (v) {
          this.loadItem(v);
        }
      }
    }
  },
  async mounted() {
    this.organizations = (await this.getOrganizations()).data.value;
    this.provider = new ODataProvider(this.$axiosHttp, this.url, getHeaders());
  },
  methods: {
    ...mapActions("plansMembers", [
      "addBroker",
      "updateBroker",
      "getBrokerById",
      // "deleteBroker",
      "getBrokerOrganizations",
      "assignBroker",
    ]),
    ...mapActions("applicationUsers", ["getOrganizations"]),
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    trans(item, field) {
      return translate2(item, field);
    },
    addItem() {
      this.item = {
        Identity: {},
        // Address: {}
      };
      this.isNew = true;
      this.dialogs.edit = true;
    },
    async editItem(item) {
      this.id = item.Id;
      this.isNew = false;
      this.dialogs.edit = true;
    },
    async loadItem(effectiveDate) {
      console.log("LOAD")
      if (!this.isNew) {
        this.loading = true;
        try {
          if (this.lockId) {
            this.item = (
              await this.getBrokerById({
                date: effectiveDate,
                id: this.id,
              })
            ).data;
          } else {
            this.item = await this.lock(
              this.getBrokerById,
              {
                date: effectiveDate,
                id: this.id,
                dialogs: this.dialogs,
                dialog: "edit",
              },
              () => {
                this.dialogs.edit = false;
              }
            );
          }
          // if (!this.item.Address) this.item.Address = {};
          //console.log(this.item);
          this.dialogs.edit = true;
        } catch (error) {
          this.error = error;
        } finally {
          this.loading = false;
        }
      }
    },
    // async deleteItem() {
    //   try {
    //     this.saving = true;
    //     await this.deleteInsuranceCarrierIndex({
    //       id: this.item.Id,
    //     });
    //     this.snackbar = true;
    //     this.dialogs.delete = false;
    //     await this.$refs.table.getDataAsync();
    //   } catch (error) {
    //     this.error = error;
    //   }
    //   this.saving = false;
    // },
    async assignItem(item) {
      this.loading = true;
      try {
        // if (this.lockId) {
          this.item = (
            await this.getBrokerOrganizations({
              id: item.Id,
            })
          ).data;
        // } else {
        //   this.item = await this.lock(
        //     this.getBrokerOrganizations,
        //     {
        //       id: item.Id,
        //       dialogs: this.dialogs,
        //       dialog: "assign",
        //     },
        //     () => {
        //       this.dialogs.assign = false;
        //     }
        //   );
        // }
        this.dialogs.assign = true;
        console.log(this.item);
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.item));
      item.BrokerageName = item.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].BrokerageName;
      item.EffectiveDate = this.effectiveDate;
      if (this.isNew) {
        this.add(item);
      } else {
        this.update(item);
      }
    },
    async update(item) {
      this.saving = true;
      delete item.Identity;
      try {
        await this.updateBroker({
          id: item.IdentityId,
          payload: item,
        });
        this.snackbar = true;
        this.dialogs.edit = false;
        this.effectiveDate = null;
        this.item = null;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async add(item) {
      this.saving = true;
      try {
        await this.addBroker({
          payload: item,
        });
        this.snackbar = true;
        this.dialogs.edit = false;
        this.effectiveDate = null;
        this.item = null;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async assign() {
      this.saving = true;
      try {
        await this.assignBroker({
          id: this.item.Id,
          payload: this.item.Organizations,
        });
        this.snackbar = true;
        this.dialogs.assign = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
